<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="accordion-container flex justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="mb-4 text-2xl text-dark-blue">Need Help?</h3>
        <p class="mb-4 text-left text-1md text-body-color">
          Read more about each connection step below, email us at
          <a
            href="mailto:service@highway.com"
            class="cursor-pointer text-yellow-500"
            >service@highway.com</a
          >, or just call us at
          <a
            href="tel:19064444929"
            class="cursor-pointer text-yellow-500"
            >1-906-HIGHWAY</a
          >
          (1-906-444-4929) and tell us how we can help you. We're available on
          weekdays from 8am-5pm CT.
        </p>
        <div class="mb-4 max-h-80 w-full overflow-hidden overflow-y-scroll">
          <accordion-select
            v-for="(item, index) in helpItems"
            :key="index"
            :title="item?.title"
            :text="item?.text"
          />
          <!-- TODO: Uncomment when Brennan tells to do that  -->
          <!-- <div class="flex items-center">
            <p class="text-dark-blue text-2xs mb-1 uppercase font-bold">how can we assist?</p>
          </div>
          <textarea
            @input="handleChange"
            placeholder="Describe the issue in as much detail as possible to help us assist you."
            class="bg-off-white text-dark-gray text-1md h-20 p-2 px-3 rounded-md mb-4 w-full placeholder-gray-over-dark border border-transparent hover:border-placeholder-gray focus:bg-white"
            v-model="message"
            name="message"
          />
          <button-main
            :disabled="!message || message.length < 5" 
            class="text-1md" 
            @click="() => sendMessage(this.message)"
          >
            Submit
          </button-main> -->
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import AccordionSelect from '@/components/AccordionSelect.vue';
// import ButtonMain from "@/components/Button.vue";

export default {
  name: 'NeedHelpModal',
  components: {
    Modal,
    // ButtonMain,
    AccordionSelect,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
  data() {
    return {
      message: '',
      showItem: false,
      helpItems: [
        {
          title: 'Identity',
          text: 'We source information about a carrier’s identity  from publicly available data on file with the FMCSA. Carrier owners or operators are encouraged to contact the <a href="https://li-public.fmcsa.dot.gov/LIVIEW/PKG_REGISTRATION.prc_option" class="underline">Department of Transportation (DOT)</a> directly to request any necessary changes to the public record. This includes any issues with a carrier’s authority, address information, and/or contact information. </br> </br> Dispatch contact information is sourced from surveys completed by our logistics coordinators.',
        },
        {
          title: 'Operations',
          text: "We source information about a carrier's total power units, total drivers, and fleet from publicly available  FMCSA data, including what is submitted in  form MCS-150.",
        },
        {
          title: 'Lanes',
          text: "A carrier’s observed lane information is sourced from publicly available inspection data while information about a carrier's preferred lanes and regions is sourced from surveys completed by our logistics coordinators.",
        },
        {
          title: 'Certifications',
          text: 'We independently verify a carrier’s Hazmat, Smartway, and Carb Tru certification status from third party sources. For all other certifications, we rely on the carrier to self-report its status.',
        },
        {
          title: 'Insurance',
          text: 'We are committed to rapidly obtaining and accurately processing carrier certificates of insurance (COI), which we request immediately during the connection process. If a carrier’s COI is already on file, we will request an updated COI at the time of renewal, as defined by the policy expiration dates captured on the COI.',
        },
        {
          title: 'Payment',
          text: 'A carrier’s payment methods and terms are kept private and secure. If a new payment method is added to a carrier’s account, all active users on the account will be emailed an alert with information about the new payment method and the user responsible for adding it.',
        },
        {
          title: 'Questionnaire',
          text: 'If a carrier answers a broker’s question, we will pre-populate the same question asked by a different broker with that same answer.',
        },
        {
          title: 'Contract',
          text: 'Signers of the broker/carrier agreement must be authorized to sign agreements on behalf of the carrier. If a user does not have this authority, the user should exit the connection process and request that an authorized representative of the carrier complete the connection process instead.',
        },
      ],
    };
  },
  methods: {
    toggleAccordion() {
      this.showItem = !this.showItem;
    },
    async sendMessage(message) {
      const carrier_id = this.$store.state.carriers?.carrierDetails?.id;
      let payload = {
        message,
        carrier_id,
      };
      let response = await this.$store.dispatch(
        'editRequest/createEditRequest',
        payload
      );
      if ([200, 201].includes(response.status)) {
        this.$toast.open({
          message: 'Message sent',
          type: 'success',
          duration: 5000,
          dismissible: true,
          position: 'top-right',
        });
      } else {
        this.$toast.open({
          message: response.statusText,
          type: 'success',
          duration: 5000,
          dismissible: true,
          position: 'top-right',
        });
      }
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .accordion-container {
    width: 500px;
  }
}
</style>
